import { useEffect, useRef, useState } from "react";
import { Alert, Button, Stack } from "@leylion/design-system";
import { getCashierRefundDocument } from "../api/client";
import { valueError } from "../shared/value-copy";
import { refundDocumentHtml } from "./refund-document-print";

export function RefundDocumentPanel({ orderId, refundId, refundNumber, language }: { orderId: string; refundId: string; refundNumber: string; language: "ar" | "en" }) {
  const ar = language === "ar";
  const [busy, setBusy] = useState(false); const [error, setError] = useState(""); const [url, setUrl] = useState("");
  const current = useRef(0); const urlRef = useRef(""); const pending = useRef(false);
  useEffect(() => {
    ++current.current; setUrl(""); setError(""); setBusy(false); pending.current = false;
    return () => { ++current.current; if (urlRef.current) URL.revokeObjectURL(urlRef.current); urlRef.current = ""; };
  }, [orderId, refundId, language]);
  const prepare = async () => {
    if (pending.current) return;
    const generation = current.current; pending.current = true; setBusy(true); setError("");
    if (urlRef.current) URL.revokeObjectURL(urlRef.current); urlRef.current = ""; setUrl("");
    try {
      const doc = await getCashierRefundDocument(orderId, refundId);
      if (generation !== current.current) return;
      if (doc.refund.id !== refundId || doc.refund.orderId !== orderId || doc.refund.status !== "Completed")
        throw new Error(ar ? "تعذر التحقق من مستند الاسترداد." : "The refund document could not be verified.");
      const script = new URL(`${import.meta.env.BASE_URL}refund-document-print.js`, location.href).href;
      urlRef.current = URL.createObjectURL(new Blob([refundDocumentHtml(doc, language, script)], { type: "text/html" }));
      setUrl(urlRef.current);
    } catch (caught) { if (generation === current.current) setError(valueError(caught, language)); }
    finally { if (generation === current.current) { pending.current = false; setBusy(false); } }
  };
  return <Stack><Button data-testid="refund-document-prepare" variant="secondary" disabled={busy} onClick={() => void prepare()}>
    {busy ? (ar ? "جارٍ تجهيز الإيصال…" : "Preparing receipt…") : (ar ? "طباعة / إعادة طباعة إيصال الاسترداد" : "Print / reprint refund receipt")} · {refundNumber}</Button>
    {error ? <Alert tone="danger" title={ar ? "تعذرت الطباعة؛ الاسترداد محفوظ" : "Print failed; the refund is saved"}>{error}</Alert> : null}
    {url ? <a data-testid="refund-document-page" href={url} target="_blank" rel="noopener noreferrer">{ar ? "فتح إيصال الاسترداد للطباعة" : "Open refund receipt for printing"}</a> : null}
  </Stack>;
}
